import { React, useEffect, useState } from "react";
import ToolsTab from "../../../components/toolsTab";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import VideoBanner from "../../../components/videoBanner";
import img_microorganismo from "../../../assets/images/img_microorganismo.png";
import ico_lombriz from "../../../assets/icons/ico_lombriz.svg";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const SoilAnalysisScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const tierra =
    "HjyRkO00u_8";
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);
  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={tierra}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit  ">
            <div className="absolute right-0 mt-[25rem] mr-[5rem] rotate-12 mb-10">
              <img
                src={img_microorganismo}
                className="lg:w-[45rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>

            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
              <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[70rem] col-span-2 lg:h-[75rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Microorganismos y fauna del suelo"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Análisis biológico <br /> de suelos
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        <b>
                          Un análisis de suelo permite cuantificar la población
                          microbiológica del suelo y, en general, evaluar la
                          calidad del suelo
                        </b>
                        . También permite detectar la presencia o ausencia de
                        patógenos que podrían afectar un cultivo.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        El primer paso de un análisis de suelo es determinar en
                        <span>
                          <b> qué sitio del paisaje </b>
                        </span>
                        se quiere realizar el estudio y, posteriormente,{" "}
                        determinar los sitios de muestreo que permitan obtener
                        muestras representativas del suelo que se va a analizar.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Los <b>estudios microbiológicos del suelo</b> analizan
                        los microorganismos presentes, tales como bacterias,
                        hongos, protozoarios y microalgas. Otros estudios
                        también analizan la presencia de la micro, meso y
                        macrofauna.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
              </div>
              <div className="relative col-span-3 2xl:mt-[11rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
                    <img
                      src=""
                      className="w-[50rem] mt-[3.5rem] right-0 absolute z-0 top-0"
                    ></img>
                    <div className="h-44 w-full bg-[#F77E0B] relative 2xl:mt-[25.6rem] xl:mt-0 md:mt-0 sm:mt-0 mt-0 pl-20">
                      <div className="grid grid-cols-2 grid-rows-1 relative text-white">
                        <div className="inline-flex items-center py-5 ml-10">
                          <img loading="lazy" src={ico_lombriz}></img>
                          <label className="ml-5 text-2xl font-bold">
                            Microorganismos <br /> y fauna del suelo
                          </label>
                        </div>
                        <p className="py-10 text-lg">
                          Microorganismos como bacterias, hongos, microalgas.
                          Animales de la microfauna, mesofauna y macrofauna del
                          suelo como nemátodos, ácaros, artrópodos, lombrices,
                          moluscos e insectos.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                    <ToolsTab
                      firstTitle="Bosques y plantaciones"
                      secondTitle="Resultados y beneficios"
                      firstTab={
                        <p>
                      Los análisis de suelo pueden realizarse en bosques, con el fin de conocer la diversidad biológica, o en zonas productivas, para conocer la aptitud del suelo para determinados cultivos.                        
                      </p>
                      }
                      secondTab={
                        <div>
                          <p className="text-xl mb-5">
                          En plantaciones, un análisis de suelos puede evidenciar la calidad y aptitud del suelo para la producción, puede indicar la presencia de plagas o patógenos de cultivos.
                          </p>
                          <p className="text-xl mb-5">
                            El análisis puede indicar usos extensivos del suelo
                            y puede brindar información para tomar medidas para
                            recuperar el suelo.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute overflow-hidden ">
            <VideoBanner idVideo={tierra}></VideoBanner>
            <div className=" absolute right-0 bottom-0 ">
              <img
                src={img_microorganismo}
                className="lg:w-[30rem] md:w-[20rem] sm:w-[12rem] w-[12rem] rotate-12"
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
              <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              <div className="lg:h-44 md:h-40 sm:h-32 h-32 w-full bg-[#F77E0B] relative">
                <div className="grid grid-cols-2 grid-rows-1 relative text-white   ">
                  <div className=" inline-flex justify-center w-full absolute lg:py-5 md:py-5 sm:py-2 py-2 lg:px-10 md:px-5 sm:px-5 px-5">
                    <div className="w-fit  mr-2">
                      <img
                        src={ico_lombriz}
                        className="lg:w-20 md:w-14 sm:w-14 w-14"
                      ></img>
                    </div>
                    <div className="">
                      <div className="inline-flex items-center  ">
                        <label className=" lg:text-2xl md:text-xl sm:text-lg text-lg font-bold">
                          Macroinvertebrados
                        </label>
                      </div>
                      <div className=" w-full">
                        <p className="lg:text-lg md:text-base sm:text-xs text-xs">
                          Este grupo está compuesto por animales de distintos
                          grupos taxonómicos, incluyendo insectos, arañas,
                          cangrejos, conchas y camarones, entre otros.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ToolsInfoSection
                firstIcon={ico_handy_orange}
                secondIcon={ico_huellas_green}
                tag="Microorganismos y fauna del suelo"
                title={
                  <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                    Análisis biológico de suelos
                  </h1>
                }
                text={
                  <div>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      <b>
                        Un análisis de suelo permite cuantificar la población
                        microbiológica del suelo y, en general, evaluar la
                        calidad del suelo
                      </b>
                      .<br /> También permite detectar la presencia o ausencia
                      de patógenos que podrían afectar un cultivo
                    </p>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      El primer paso de un análisis de suelo es determinar en{" "}
                      <span>
                        <b> qué sitio del paisaje </b>
                      </span>{" "}
                      se quiere realizar el estudio y, posteriormente,
                      determinar los sitios de muestreo que permitan obtener
                      muestras representativas del suelo que se va a analizar.
                    </p>
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-32">
                      Los <b>estudios microbiológicos del suelo</b> analizan los
                      microorganismos presentes, tales como bacterias, hongos,
                      protozoarios y microalgas. Otros estudios también analizan
                      la presencia de la micro, meso y macrofauna
                    </p>
                  </div>
                }
              ></ToolsInfoSection>
            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
              <ToolsTab
                firstTitle="Bosques y plantaciones"
                secondTitle="Resultados y beneficios"
                firstTab={
                  <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    Sus resultados y beneficios se relacionan con el
                    conocimiento preciso de la calidad del agua y la salud de
                    los ecosistemas que forman parte del sitio en que se realiza
                    la operación.
                  </p>
                }
                secondTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Sus resultados y beneficios se relacionan con el
                      conocimiento preciso de la calidad del agua y la salud de
                      los ecosistemas que forman parte del sitio en que se
                      realiza la operación.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Además, brinda información directa sobre los impactos de
                      actividades productivas en el medio ambiente. Un ejemplo
                      de ello puede ser el impacto de las aguas residuales de
                      una operación o de un sobreuso de agroquímicos sobre los
                      cuerpos de agua locales.
                    </p>
                  </div>
                }
              ></ToolsTab>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SoilAnalysisScreen;
